import React from 'react';
import { Instagram, Facebook, Linkedin, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#111111] pt-20 pb-10 px-6 border-t border-gold/20" data-id="element-126">
      <div className="max-w-7xl mx-auto" data-id="element-127">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-128">
          {/* Brand */}
          <div className="lg:col-span-1" data-id="element-129">
            <img src="https://cdn.magicpatterns.com/uploads/ef9QvYtTkNXd4Uer9fAQSB/JennyGong2.png" alt="Jenny Gong - Las Vegas Real Estate" className="h-20 brightness-0 invert mb-6" data-id="element-130" />
            <p className="text-white/50 font-light text-sm leading-relaxed mb-6" data-id="element-131">
              Curating the finest luxury real estate experiences in Las Vegas,
              Henderson, and surrounding exclusive communities.
            </p>
            <div className="flex gap-4" data-id="element-132">
              <a href="#" className="text-white/50 hover:text-gold transition-colors" data-id="element-133">
                <Instagram className="w-5 h-5" data-id="element-134" />
              </a>
              <a href="#" className="text-white/50 hover:text-gold transition-colors" data-id="element-135">
                <Facebook className="w-5 h-5" data-id="element-136" />
              </a>
              <a href="#" className="text-white/50 hover:text-gold transition-colors" data-id="element-137">
                <Linkedin className="w-5 h-5" data-id="element-138" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-139">
            <h4 className="text-white font-serif text-lg mb-6" data-id="element-140">Navigation</h4>
            <ul className="space-y-4" data-id="element-141">
              <li data-id="element-142">
                <a href="#" className="text-white/50 hover:text-gold transition-colors text-sm uppercase tracking-wider" data-id="element-143">
                  Home
                </a>
              </li>
              <li data-id="element-144">
                <a href="#communities" className="text-white/50 hover:text-gold transition-colors text-sm uppercase tracking-wider" data-id="element-145">
                  Communities
                </a>
              </li>
              <li data-id="element-146">
                <a href="#listings" className="text-white/50 hover:text-gold transition-colors text-sm uppercase tracking-wider" data-id="element-147">
                  Listings
                </a>
              </li>
              <li data-id="element-148">
                <a href="#why-vegas" className="text-white/50 hover:text-gold transition-colors text-sm uppercase tracking-wider" data-id="element-149">
                  Why Vegas
                </a>
              </li>
            </ul>
          </div>

          {/* Communities */}
          <div data-id="element-150">
            <h4 className="text-white font-serif text-lg mb-6" data-id="element-151">Top Areas</h4>
            <ul className="space-y-4" data-id="element-152">
              <li data-id="element-153">
                <a href="#" className="text-white/50 hover:text-gold transition-colors text-sm uppercase tracking-wider" data-id="element-154">
                  Summerlin
                </a>
              </li>
              <li data-id="element-155">
                <a href="#" className="text-white/50 hover:text-gold transition-colors text-sm uppercase tracking-wider" data-id="element-156">
                  Southern Highlands
                </a>
              </li>
              <li data-id="element-157">
                <a href="#" className="text-white/50 hover:text-gold transition-colors text-sm uppercase tracking-wider" data-id="element-158">
                  Henderson
                </a>
              </li>
              <li data-id="element-159">
                <a href="#" className="text-white/50 hover:text-gold transition-colors text-sm uppercase tracking-wider" data-id="element-160">
                  MacDonald Highlands
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-161">
            <h4 className="text-white font-serif text-lg mb-6" data-id="element-162">Contact</h4>
            <ul className="space-y-4 text-white/50 text-sm font-light" data-id="element-163">
              <li className="flex items-start gap-3" data-id="element-164">
                <span className="text-gold mt-1" data-id="element-165">📍</span>
                <span data-id="element-166">
                  8400 W Sahara Ave
                  <br data-id="element-167" />
                  Las Vegas, NV 89117
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-168">
                <span className="text-gold" data-id="element-169">📞</span>
                <a href="tel:+18583978218" className="hover:text-gold transition-colors" data-id="element-170">
                  (858) 397-8218
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-171">
                <span className="text-gold" data-id="element-172">
                  <Mail className="w-4 h-4" data-id="element-173" />
                </span>
                <a href="mailto:jenny@jennygong.com" className="hover:text-gold transition-colors" data-id="element-174">
                  jenny@jennygong.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-175">
          <p className="text-white/30 text-xs uppercase tracking-widest" data-id="element-176">
            &copy; {new Date().getFullYear()} Jenny Gong Real Estate. All rights
            reserved.
          </p>
          <div className="flex gap-6 text-white/30 text-xs uppercase tracking-widest" data-id="element-177">
            <a href="#" className="hover:text-white transition-colors" data-id="element-178">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-179">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}